import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PartnerPortalLayout } from './PartnerPortalLayout';
import { SearchIcon, FilterIcon, TargetIcon, TrendingUpIcon, SparklesIcon } from 'lucide-react';
export function BookAnalyzerPage() {
  const [selectedGroup, setSelectedGroup] = useState(0);
  const groups = [{
    client: 'Finova Capital',
    fit: 98,
    event: 'Annual Leadership Summit',
    date: 'Oct 12 - 15, 2026',
    lift: '+$45,000',
    status: 'Eligible',
    headcount: 45,
    currentValue: '$125,000',
    recommended: 'AI Leadership Retreat',
    whyFit: 'Their primary goal is: "Align partners on new AI investment thesis and operational adoption.". This aligns perfectly with the core curriculum of the AI Leadership Retreat.',
    confidence: 'High (85%). High - Event is 3 months out.'
  }, {
    client: 'Helix Health',
    fit: 95,
    event: 'Post-Merger Integration',
    date: 'Sep 20 - 22, 2026',
    lift: '+$25,000',
    status: 'In Discussion',
    headcount: 120,
    currentValue: '$85,000',
    recommended: 'Executive Alignment Retreat',
    whyFit: 'Recent merger indicates high need for culture alignment and team integration exercises.',
    confidence: 'Medium (60%). Currently discussing with HR director.'
  }, {
    client: 'NorthBridge Tech',
    fit: 92,
    event: 'Q4 Strategy Offsite',
    date: 'Nov 02 - 04, 2026',
    lift: '+$28,000',
    status: 'Proposal Sent',
    headcount: 60,
    currentValue: '$95,000',
    recommended: 'Executive Alignment Retreat',
    whyFit: 'Annual strategy planning session requires structured facilitation and alignment frameworks.',
    confidence: 'High (90%). Proposal under review by executive sponsor.'
  }, {
    client: 'Aurora Consumer',
    fit: 82,
    event: 'Innovation Week',
    date: 'Jan 10 - 14, 2027',
    lift: '+$55,000',
    status: 'Eligible',
    headcount: 200,
    currentValue: '$320,000',
    recommended: 'AI Leadership Retreat',
    whyFit: 'Innovation focus aligns with AI curriculum. Large group size presents significant upsell opportunity.',
    confidence: 'Medium (50%). Early stages, event is 6+ months out.'
  }, {
    client: 'Global Logistics',
    fit: 75,
    event: 'Sales Kickoff',
    date: 'Feb 05 - 08, 2027',
    lift: '+$15,000',
    status: 'Eligible',
    headcount: 350,
    currentValue: '$450,000',
    recommended: 'Custom Wellness Track',
    whyFit: 'High-energy sales kickoff could benefit from structured wellness and recovery options.',
    confidence: 'Low (30%). Budget may be constrained for additional programming.'
  }];
  const selected = groups[selectedGroup];
  return <PartnerPortalLayout data-id="element-4926">
      <div className="p-6 lg:p-10 max-w-7xl mx-auto h-[calc(100vh-4rem)] flex flex-col" data-id="element-4927">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 shrink-0" data-id="element-4928">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} data-id="element-4929">
            <h1 className="font-serif-display text-3xl md:text-4xl font-bold text-[#0B1B3B] mb-2" data-id="element-4930">
              Existing Book Analyzer
            </h1>
            <p className="text-slate-500" data-id="element-4931">
              Review your booked groups to identify high-probability retreat
              upsells.
            </p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="flex items-center gap-3" data-id="element-4932">
            <div className="relative w-64 hidden sm:block" data-id="element-4933">
              <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" data-id="element-4934" />
              <input type="text" placeholder="Search booked groups..." className="w-full pl-9 pr-4 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition-colors outline-none" data-id="element-4935" />
            </div>
            <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors" data-id="element-4936">
              <FilterIcon className="w-4 h-4" data-id="element-4937" />
              Filter
            </button>
          </motion.div>
        </div>

        <div className="flex flex-col lg:flex-row gap-6 flex-1 min-h-0" data-id="element-4938">
          {/* Left List */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2
        }} className="w-full lg:w-[40%] bg-white rounded-xl border border-slate-200 shadow-sm flex flex-col overflow-hidden" data-id="element-4939">
            <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between bg-slate-50/50 shrink-0" data-id="element-4940">
              <h2 className="text-xs font-bold text-slate-500 uppercase tracking-wider" data-id="element-4941">
                Booked Groups
              </h2>
              <span className="text-xs font-medium bg-white border border-slate-200 px-2 py-1 rounded-md text-slate-600" data-id="element-4942">
                {groups.length} Total
              </span>
            </div>
            <div className="overflow-y-auto flex-1" data-id="element-4943">
              {groups.map((group, i) => <button key={i} onClick={() => setSelectedGroup(i)} className={`w-full text-left p-5 border-b border-slate-100 transition-colors relative ${selectedGroup === i ? 'bg-amber-50/30' : 'hover:bg-slate-50'}`} data-id="element-4944">
                  {selectedGroup === i && <div className="absolute left-0 top-0 bottom-0 w-1 bg-amber-500" data-id="element-4945" />}
                  <div className="flex justify-between items-start mb-1" data-id="element-4946">
                    <h3 className={`font-serif-display text-xl font-bold ${selectedGroup === i ? 'text-[#0B1B3B]' : 'text-slate-800'}`} data-id="element-4947">
                      {group.client}
                    </h3>
                    <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${group.fit >= 90 ? 'bg-emerald-100 text-emerald-700' : group.fit >= 80 ? 'bg-amber-100 text-amber-700' : 'bg-slate-100 text-slate-600'}`} data-id="element-4948">
                      {group.fit} Fit
                    </span>
                  </div>
                  <div className="text-xs text-slate-500 mb-3" data-id="element-4949">
                    {group.event} • {group.date}
                  </div>
                  <div className="flex justify-between items-center" data-id="element-4950">
                    <span className="text-sm font-bold text-emerald-600" data-id="element-4951">
                      {group.lift} Lift
                    </span>
                    <span className="text-[10px] font-medium text-slate-400 uppercase tracking-wider" data-id="element-4952">
                      {group.status}
                    </span>
                  </div>
                </button>)}
            </div>
          </motion.div>

          {/* Right Detail Panel */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3
        }} className="w-full lg:w-[60%] bg-white rounded-xl border border-slate-200 shadow-sm flex flex-col overflow-hidden" data-id="element-4953">
            {/* Header */}
            <div className="bg-[#0B1B3B] text-white p-8 shrink-0" data-id="element-4954">
              <div className="flex items-center gap-2 mb-4" data-id="element-4955">
                <SparklesIcon className="w-4 h-4 text-amber-500" data-id="element-4956" />
                <span className="text-[10px] font-bold text-amber-500 uppercase tracking-wider" data-id="element-4957">
                  High-Probability Upsell
                </span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6" data-id="element-4958">
                <div data-id="element-4959">
                  <h2 className="font-serif-display text-3xl md:text-4xl font-bold mb-2" data-id="element-4960">
                    {selected.client}
                  </h2>
                  <p className="text-slate-300 text-sm" data-id="element-4961">
                    {selected.event} • {selected.headcount} Executives
                  </p>
                </div>
                <div className="sm:text-right" data-id="element-4962">
                  <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-4963">
                    Current Booking Value
                  </div>
                  <div className="font-serif-display text-3xl font-bold" data-id="element-4964">
                    {selected.currentValue}
                  </div>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="p-8 flex-1 overflow-y-auto" data-id="element-4965">
              <div className="bg-slate-50 rounded-xl border border-slate-100 p-6 mb-8" data-id="element-4966">
                <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4 mb-6" data-id="element-4967">
                  <div data-id="element-4968">
                    <div className="text-[10px] font-bold text-amber-600 uppercase tracking-wider mb-2" data-id="element-4969">
                      Recommended Upgrade
                    </div>
                    <h3 className="font-serif-display text-2xl font-bold text-[#0B1B3B]" data-id="element-4970">
                      {selected.recommended}
                    </h3>
                  </div>
                  <div className="sm:text-right" data-id="element-4971">
                    <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-4972">
                      Est. Incremental Revenue
                    </div>
                    <div className="font-serif-display text-3xl font-bold text-emerald-600" data-id="element-4973">
                      {selected.lift}
                    </div>
                  </div>
                </div>

                <div className="grid sm:grid-cols-2 gap-8 pt-6 border-t border-slate-200" data-id="element-4974">
                  <div data-id="element-4975">
                    <div className="flex items-center gap-2 mb-3" data-id="element-4976">
                      <TargetIcon className="w-4 h-4 text-amber-600" data-id="element-4977" />
                      <h4 className="text-sm font-bold text-[#0B1B3B]" data-id="element-4978">
                        Why it's a fit
                      </h4>
                    </div>
                    <p className="text-sm text-slate-600 leading-relaxed" data-id="element-4979">
                      {selected.whyFit}
                    </p>
                  </div>
                  <div data-id="element-4980">
                    <div className="flex items-center gap-2 mb-3" data-id="element-4981">
                      <TrendingUpIcon className="w-4 h-4 text-amber-600" data-id="element-4982" />
                      <h4 className="text-sm font-bold text-[#0B1B3B]" data-id="element-4983">
                        Sales Confidence
                      </h4>
                    </div>
                    <p className="text-sm text-slate-600 leading-relaxed" data-id="element-4984">
                      {selected.confidence}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </PartnerPortalLayout>;
}